import Add from './add/CanAddEventNoteInitialState'

const { Record } = require('immutable');

export default Record({
    add: Add()
});